<script setup lang="ts">
import { useI18n } from '../../../i18n'

/** Placeholder card with a spinner while the deck loads. */
const { t } = useI18n()
</script>

<template>
  <div class="deck-skel">
    <div class="deck-skel__frame">
      <div class="deck-skel__title">{{ t('deckPlayer.host.loadingDeck') }}</div>
      <div class="deck-skel__card">
        <div class="deck-skel__overlay">
          <svg
            class="deck-skel__spinner"
            viewBox="0 0 50 50"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <circle
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke="currentColor"
              stroke-width="4"
              stroke-linecap="round"
              stroke-dasharray="80 40"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.deck-skel__frame {
  width: min(100%, 600px);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.deck-skel__title {
  font-size: 1.05rem;
  font-weight: 650;
  color: var(--pl-color-text, #0f172a);
  padding: 0.5rem 0;
  opacity: 0.45;
}

.deck-skel__card {
  position: relative;
  background: #f1f5f9;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  aspect-ratio: 3 / 2;
  overflow: hidden;
}

.deck-skel__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
}

.deck-skel__spinner {
  width: 2.5rem;
  height: 2.5rem;
  animation: pfc-skel-spin 1s linear infinite;
}

@keyframes pfc-skel-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
